import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { StorageService } from '../../services/storage/storage.service';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const storageService = inject(StorageService);
    const router = inject(Router);
    const cookies = storageService.allCookie();
    const tokenObj = cookies.find(cookie => cookie.key === 'auth_token');
    const token = tokenObj ? tokenObj.value : null;
    const clonedReq = token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` }, withCredentials: true }) : req;
    return next(clonedReq).pipe(
        catchError(error => {
            if (error.status === 401) {
                storageService.deleteCookie('auth_token');
                console.warn('Unauthorized! Redirecting to login...');
                router.navigate(['/auth/login']);
            }
            return throwError(() => error);
        })
    );
};